import { RealEstatePreview } from '../../../@types/preview-types'

export const realEstatePreviewResponseToApp = (realEstatePreviewLiteral: string): RealEstatePreview => {
  const realEstatePreview = JSON.parse(realEstatePreviewLiteral)
  return {
    url: realEstatePreview.url,
    expose: realEstatePreview.exposeDto,
    exposeToken: realEstatePreview.exposeDtoToken,
    realtor: realEstatePreview.realtorDto,
    realtorToken: realEstatePreview.realtorDtoToken,
  }
}
